import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const DialogLetterhead = ({handleGenerateLote,showDialogLetter, setShowDialogLetter, letterhead, setLetterhead, selectedExams, id_company, start_date, end_date, isLoading}) => {

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const generateLote = () => {
        handleGenerateLote(selectedExams);
        setShowDialogLetter(false);
    };
    
    const footer = (
        <div style={{ display: "flex", gap: "1px", justifyContent: "flex-end" }}>
    
            <Button 
                color="primary" 
                size="sm"
                onClick={ generateLote}
                style={{
                    padding: "2px",
                    fontSize: "12px",
                    height: "35px",
                    width: "100px",
                    display: "Fe",
                    alignItems: "center",
                    justifyContent: "center",
                    background: isLoading ? "#888888" : "#006d97",
                     cursor: isLoading ? "not-allowed" : "pointer"

                }}
                   disabled={isLoading}
                
            >
                Generar Lote
            </Button>
    
    
            <Button 
                color="danger" 
                size="sm"
                onClick={() => setShowDialogLetter(false)}
            
                style={{
                    padding: "2px",
                    fontSize: "12px",
                    height: "35px",
                    width: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                Cancelar
            </Button>
        </div>
    );
    
    return (
        <Dialog
            header="Impresión de resultados"
            visible={showDialogLetter}
            modal
            onHide={() => setShowDialogLetter(false)}
            closable={true}
            dismissableMask={false}
            className="medium-dialog"
            footer={footer}
        >

            <DataTable
                value={[
                    {
                        empresa: id_company?.label || "No seleccionada",
                        fechas: `${start_date} — ${end_date}`,
                        membretado: letterhead
                    }
                ]}
                showGridlines
                className="data-table p-datatable-striped p-datatable-sm"
            >
                <Column
                    header='Empresa'
                    body={(rowData) => (
                        <div style={{ textAlign: "center", padding: "8px" }}>
                            {rowData.empresa}
                        </div>
                    )}
                headerStyle={headerStyle} style={cellStyle} 
                />

                <Column
                    header='Rango de fechas'
                    body={(rowData) => (
                        <div style={{ textAlign: "center", padding: "8px" }}>
                            {rowData.fechas}
                        </div>
                    )}
                headerStyle={headerStyle} style={cellStyle} 
                />

                <Column
                    header='Membretado'
                    body={(rowData) => (
                        <div style={{ textAlign: "center", padding: "8px" }}>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={rowData.membretado}
                                    onChange={(e) => setLetterhead(e.target.checked)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    )}
                headerStyle={headerStyle} style={cellStyle} 
                />
            </DataTable>
        </Dialog>


    );
};
